import React from "react";

import BadgeOutlinedIcon from "@mui/icons-material/BadgeOutlined";
import { Box, Divider, Stack, Typography } from "@mui/material";
import { EmailIcon, FirmIcon, LocationIcon, MobilePhoneIcon, PersonIcon } from "assets/material-custom-icons";
import { MaterialTooltip } from "components/tooltips/MaterialTooltip";
import { ICapitalSeeker } from "store/types";

import { getFullName } from "./Contact";

export const ContactItem: React.FC<{ contact: ICapitalSeeker }> = ({ contact }) => {
  const fullName = getFullName(contact);
  const fields = ["first_name", "last_name", "phone_number", "email", "firm", "title", "address"];

  const allFieldsEmpty = fields.every((key) => !contact[key as keyof ICapitalSeeker]);
  if (allFieldsEmpty) return null;

  return (
    <Box>
      {fullName.trim() && (
        <Typography
          variant="h6"
          sx={{
            fontSize: "20px",
            fontWeight: "600",
            color: "#071F35",
            marginBottom: "16px",
            fontFamily: "sans-serif"
          }}
        >
          {fullName}
        </Typography>
      )}

      <Stack gap="10px">
        {contact.pivot?.deal_role_label && (
          <ContactField
            icon={<BadgeOutlinedIcon sx={{ fontSize: "16px", color: "#496682" }} />}
            value={contact.pivot.deal_role_label}
          />
        )}

        {contact.phone_number && (
          <ContactField
            icon={<MobilePhoneIcon sx={{ fontSize: "16px", color: "#496682" }} />}
            value={contact.phone_number}
          />
        )}

        {contact.email && (
          <ContactField icon={<EmailIcon sx={{ fontSize: "16px", color: "#496682" }} />} value={contact.email} />
        )}

        {contact.firm && <ContactField icon={<FirmIcon />} value={contact.firm} />}

        {contact.title && (
          <ContactField icon={<PersonIcon sx={{ fontSize: "16px", color: "#496682" }} />} value={contact.title} />
        )}

        {contact.address && (
          <ContactField icon={<LocationIcon sx={{ fontSize: "16px", color: "#496682" }} />} value={contact.address} />
        )}
      </Stack>

      {/* Divider */}
      <Divider sx={{ marginTop: "16px", borderColor: "#e0e0e0" }} />
    </Box>
  );
};

interface ContactFieldProps {
  icon: React.ReactNode;
  value: string;
}

const ContactField: React.FC<ContactFieldProps> = ({ icon, value }) => (
  <Stack direction="row" alignItems="center" gap="10px">
    {icon}
    <MaterialTooltip isShow title={value}>
      <Typography
        sx={{ fontSize: "15px", color: "#071F35", overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }}
      >
        {value}
      </Typography>
    </MaterialTooltip>
  </Stack>
);
